import type {
  AnswerChoicesRankingScaleType,
  AnswerChoicesRankingType,
  AnswerChoicesType,
  AnswerUserChoicesType,
} from '~/model/AnswerUserType';
import type { QuestionReconstructedType } from '~/model/QuestionType';
import { getIdFromUri } from '@/app/utils/entities/uri';
import { apiTypes } from '~/const/api';

export const answerValidator = (
  question: QuestionReconstructedType,
  answer: AnswerUserChoicesType,
) => {
  if (!answer)
    return false;

  switch (question.type) {
    case apiTypes.GRID:
    case apiTypes.STAR_RATING:
      return (
        answer
        && Object.keys(answer.answer_choices)?.length
        === question.sub_questions.length
      );
    case apiTypes.RANKING:
    case apiTypes.RANKING_PICTURE:
      return (
        answer
        && Object.keys(answer.answer_choices)?.length
        && Object.values(
          (answer.answer_choices as AnswerChoicesRankingType).ranking,
        ).every(value =>
          Object.values(
            (answer.answer_choices as AnswerChoicesRankingType).choices,
          ).some(choice => getIdFromUri(choice) === +value),
        )
      );
    case apiTypes.RANKING_SCALE:
      return (
        answer
        && Object.keys(answer.answer_choices)?.length
        && Object.keys(
          (answer.answer_choices as AnswerChoicesRankingScaleType)
            .ranking_scale,
        ).every(value =>
          Object.values(
            (answer.answer_choices as AnswerChoicesRankingScaleType).choices,
          ).some(choice => getIdFromUri(choice) === +value),
        )
      );
    case apiTypes.CHECK:
    case apiTypes.RADIO:
    case apiTypes.SELECT:
      return (
        !!(answer.answer_choices as AnswerChoicesType)?.length
        || !!answer.value_text?.length
      );
    case apiTypes.INTEGER:
      return typeof answer.value === 'number';
    case apiTypes.TEXT:
      return !!(answer.value as string).length;
    case apiTypes.FILE:
    case apiTypes.PICTURE:
      return !!answer.media?.length;
    default:
      return true;
  }
};
